import { t } from "i18next";

import type { ColumnsClarFactory } from "@/core/components/shared/data-table";
import { Badge } from "@/core/components/ui/badge";
import { NoTranslate } from "@/core/components/ui/no-translate";
import type { ProductProviderMappingDto } from "@/features/ledger/api/dto";
import { ProductProviderMappingRowActions } from "@/features/ledger/components/product-provider-mappings/product-provider-mapping-row-actions";

/** Ligne de la liste : `DataTableClar` exige un `id` requis (optionnel dans le DTO). */
export type ProductProviderMappingRow = ProductProviderMappingDto & {
  id: string;
};

/**
 * Colonnes des associations code produit / provider
 * (`POST /ProductProviderMappings/all`). Filtres : `productCodeId`,
 * `providerId` (texte).
 */
export const productProviderMappingsColumns: ColumnsClarFactory<
  ProductProviderMappingRow
> = (navigate) => [
  {
    id: "productCodeId",
    accessorKey: "productCodeId",
    header: t("ledger.mappings.columns.productCodeId"),
    cell: ({ getValue }) => (
      <NoTranslate as="span" className="font-mono text-xs">
        {(getValue() as string) || "—"}
      </NoTranslate>
    ),
    meta: { type: "text" },
  },
  {
    id: "providerId",
    accessorKey: "providerId",
    header: t("ledger.mappings.columns.providerId"),
    cell: ({ getValue }) => (
      <NoTranslate as="span" className="font-mono text-xs">
        {(getValue() as string) || "—"}
      </NoTranslate>
    ),
    meta: { type: "text" },
  },
  {
    id: "externalConfig",
    accessorKey: "externalConfig",
    header: t("ledger.mappings.columns.externalConfig"),
    cell: ({ getValue }) => (
      <NoTranslate
        as="span"
        className="font-mono text-xs line-clamp-1 max-w-64 inline-block"
      >
        {(getValue() as string) || "—"}
      </NoTranslate>
    ),
    meta: { type: "denied" },
  },
  {
    id: "isActive",
    accessorKey: "isActive",
    header: t("ledger.mappings.columns.isActive"),
    cell: ({ getValue }) => (
      <Badge variant={getValue() ? "success" : "secondary"}>
        {getValue() ? t("ledger.common.active") : t("ledger.common.inactive")}
      </Badge>
    ),
    meta: { type: "denied" },
  },
  {
    id: "actions",
    header: t("common.actions"),
    enableHiding: false,
    cell: ({ row }) =>
      row.original.id ? (
        <ProductProviderMappingRowActions
          mapping={row.original}
          navigate={navigate}
        />
      ) : null,
    meta: { type: "denied" },
  },
];
